(function () {


	angular.module('app.widgets')
	.directive('plaPositive', plaPositive); 

	function plaPositive() {
        return {
            require: 'ngModel',
            link: function(scope, elem, attrs, ctrl) {
                if (!ctrl) return;
                ctrl.$validators.positive = function(value) {
                    return value && value > 0;
                };
            }
        }
    }

})();